export enum InputTypeEnum {
    DROPDOWN = 'DROPDOWN',
    RADIO = 'RADIO',
    CHECKBOX = 'CHECKBOX',
    TEXTBOX = 'TEXTBOX',
    TEXTAREA = 'TEXTAREA',
    DATE = 'DATE',
    CONFIRM = 'CONFIRM',
    APPLICATIONS = 'APPLICATIONS',
    CLIENTS = 'CLIENTS',
    SENTBY = 'SENTBY'
}

export class Tag {
    id: number;
    template_id: number;
    name: string;
    tag_text: string;
    tag_options: string;
    required: boolean;
    template_tag: boolean;
    prompt: string;
    input_type: InputTypeEnum;

    constructor(id?: number, template_id?: number, name?: string, tag_text?: string, required?: boolean, template_tag?: boolean, tag_options?: string, prompt?: string, input_type?: InputTypeEnum) {
        this.id = id;
        this.template_id = template_id;
        this.name = name;
        this.tag_text = tag_text || '';
        this.required = required != null ? required : true;
        this.template_tag = template_tag || false;
        this.tag_options = tag_options || '';
        this.prompt = prompt || '';
        this.input_type = input_type || InputTypeEnum.TEXTAREA;
    }

    toString() {
        return `[id: ${this.id}, name: ${this.name}, value: ${this.tag_text}, required: ${this.required}]`;
    }
}
